import {
    createRequestFilters,
    ListProviderCollectionPaymentsRequest, ListProviderRefundRequestsRequest, ProviderClaim,
    ProviderCollectionPayment,
    ProviderCollectionRefundRequest
} from '@enter/core';
import _ from 'lodash';
import { action, observable, runInAction } from 'mobx';
import { PaymentGenerator } from './payment.generator';
import { PaymentService } from './payment.service';
import { IFeatures, IItemDetail, IItemListing, IItemListingRequest } from './root.store';
import { appendTo, parseItemListingRequest } from './util';
import {OverpaymentGenerator} from "./overpayment.generator";
import {OverpaymentService} from "./overpayment.service";

export class OverpaymentStore {
    @observable public overpaymentRefunds: ProviderCollectionRefundRequest[] = [];

    private features: IFeatures;
    private overpaymentGenerator: OverpaymentGenerator;
    private overpaymentService: OverpaymentService = new OverpaymentService();

    constructor(features: IFeatures, overpaymentGenerator: OverpaymentGenerator) {
        this.features = features;
        this.overpaymentGenerator = overpaymentGenerator;
    }

    public findCollectionRefundRequest = (collectionRefundRequestId: string): ProviderCollectionRefundRequest | undefined => {
        return _.find(this.overpaymentRefunds, { id: collectionRefundRequestId });
    };

    @action
    public async unapproveRequest(id: string): Promise<ProviderCollectionRefundRequest> {
        return this.overpaymentService.unapproveRefundRequest(id);
    }

    @action
    public async approveRequest(id: string, notes: string|undefined): Promise<ProviderCollectionRefundRequest> {
        return this.overpaymentService.approveRefundRequest(id, notes);
    }

    @action
    public async loadOverpaymentRefundListing(ilr: IItemListingRequest): Promise<IItemListing<ProviderCollectionRefundRequest>> {
        const lprrr = ilr2lprrr(ilr);
        console.log("lprrr=", lprrr);
        const listing = await (this.features.isDemo
            ? this.overpaymentGenerator.loadOverpaymentListing(lprrr)
            : this.overpaymentService.fetchOverpaymentRefundRequests(lprrr));
        if (!listing) {
            throw new Error(`No refund requests available`);
        }
        const { items } = listing;
        runInAction(() => {
            this.overpaymentRefunds = appendTo<ProviderCollectionRefundRequest>(this.overpaymentRefunds, items);
        });
        return listing;
    }
}

// Convert from IItemListingRequest to ListProviderCollectionPaymentsRequest
export const ilr2lprrr = (ilr: IItemListingRequest): ListProviderRefundRequestsRequest => {
    const base = parseItemListingRequest(ilr) as ListProviderRefundRequestsRequest;
    const filters = createRequestFilters(_.get(ilr, 'filters'), true);
    return {
        ...base,
        ...filters,
    };
};
